<form [formGroup]="formGroup" class="form-container">
  <wz-form-group-part>
    <wz-form-group-part-header>Conjoint</wz-form-group-part-header>
    <div class="person-container" *ngIf="!conjointCtrl">
      <div class="no-data">Aucun conjoint</div>
      <wz-rect-button mat-button color="accent" (click)="addConjoint()"
        >Ajouter un conjoint
      </wz-rect-button>
    </div>
    <wz-form-group-part-item
      *ngIf="conjointCtrl"
      [hasDelete]="true"
      (delete)="removeConjoint()"
      formGroupName="conjoint"
    >
      <mat-form-field>
        <wz-date-input
          placeholder="Date de naissance du conjoint"
          formControlName="dateNaissance"
        ></wz-date-input>
        <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
        <mat-error
          *ngIf="conjointCtrl.get('dateNaissance').hasError('required')"
          >La date de naissance du conjoint estobligatoire
        </mat-error>
        <mat-error
          *ngIf="conjointCtrl.get('dateNaissance').hasError('majorPerson')"
          >Le conjoint doit être majeur à la date d'effet choisie
        </mat-error>
        <mat-error
          *ngIf="conjointCtrl.get('dateNaissance').hasError('max')"
          wzI18n="FORMS_BIRTHDAY_MIN"
          [wzI18nParams]="minAgeConjoint"
        >
        </mat-error>
        <mat-error
          *ngIf="conjointCtrl.get('dateNaissance').hasError('min')"
          wzI18n="FORMS_BIRTHDAY_MAX"
          [wzI18nParams]="maxAgeConjoint"
        >
        </mat-error>
        <!-- <mat-error *ngIf="conjointCtrl.get('dateNaissance').hasError('max')">La date de naissance ne peut être
          postérieure la date du jour
        </mat-error> -->
      </mat-form-field>

      <!-- <wz-checkbox formControlName="isRegimeSocialDifferent">Le régime social est
        différent pour cette
        personne
      </wz-checkbox> -->
      <wz-button-toggle
        enumItemsKey="REGIME_SOCIAL_ENUM"
        formControlName="regimeSocial"
        orientation="row"
        [fullWidth]="true"
      >
      </wz-button-toggle>
    </wz-form-group-part-item>
  </wz-form-group-part>
  <wz-form-group-part formArrayName="enfants">
    <wz-form-group-part-header>Enfants</wz-form-group-part-header>
    <div class="person-container" *ngIf="enfantsCtrl.controls.length === 0">
      <div class="no-data">Aucun enfant</div>
    </div>
    <wz-form-group-part-item
      *ngFor="
        let enfantCtrl of enfantsCtrl.controls;
        let i = index;
        let length = count
      "
      [formGroupName]="i"
      [hasDelete]="true"
      (delete)="removeChild(i)"
    >
      <wz-form-group-part-item-title
        >Enfant {{ i + 1 }}</wz-form-group-part-item-title
      >
      <mat-form-field>
        <wz-date-input
          placeholder="Date de naissance de l'enfant"
          formControlName="dateNaissance"
        ></wz-date-input>
        <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
        <mat-error *ngIf="enfantCtrl.get('dateNaissance').hasError('required')"
          >La date de naissance de l'enfant est obligatoire
        </mat-error>
        <mat-error *ngIf="enfantCtrl.get('dateNaissance').hasError('max')"
          >La date de naissance ne peut être postérieure la date du jour
        </mat-error>
        <mat-error *ngIf="enfantCtrl.get('dateNaissance').hasError('childAge')"
          >Attention au-delà de 26 ans seuls les enfants bénéficiant d'une
          allocation personne handicapée peuvent bénéficier du même contrat que
          les parents
        </mat-error>
      </mat-form-field>
      <!-- <wz-checkbox formControlName="isDisabled">Votre enfant est-il handicapé ?</wz-checkbox>
      <wz-checkbox formControlName="isRegimeSocialDifferent">Le régime social est
        différent pour cette
        personne
      </wz-checkbox> -->
      <wz-button-toggle
        enumItemsKey="REGIME_SOCIAL_ENUM"
        formControlName="regimeSocial"
        orientation="row"
        [fullWidth]="true"
      >
      </wz-button-toggle>
    </wz-form-group-part-item>
    <wz-rect-button mat-button color="accent" (click)="addChild()"
      >Ajouter un enfant
    </wz-rect-button>
  </wz-form-group-part>
</form>
